import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { personLabel } from '../../components/ApprovalLevels.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

interface AuditRow {
  readonly auditId: string;
  readonly auditEvent: string;
  readonly entityType: string;
  readonly actorName: string | null;
  readonly actorCode: string | null;
}

export function M20IntegrationAuditPage(): ReactNode {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [rows, setRows] = useState<AuditRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ data: AuditRow[] }>('/v1/integration/audit', { token })
      .then((r) => { if (alive) setRows(r.data); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('m20.audit.loading')}</p>;
  return (
    <main aria-label="integration-audit">
      <h1>{t('m20.audit.title')}</h1>
      <table aria-label="integration-audit-table">
        <thead><tr><th>{t('m20.audit.colEvent')}</th><th>{t('m20.audit.colEntity')}</th><th>{t('m20.audit.colUser')}</th></tr></thead>
        <tbody>
          {rows.map((a) => (
            <tr key={a.auditId}>
              <td>{a.auditEvent}</td>
              <td>{a.entityType}</td>
              <td>{personLabel(a.actorName, a.actorCode) ?? '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
